import { EdgeLoadHuntLabelRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadHuntLabel } from '@/shared/domain/use-cases'

export function makeLoadHuntLabel(): LoadHuntLabel {
  return new EdgeLoadHuntLabelRepository(makeSupabaseEdgeHttpClient()).execute
}
